import { CognitoUser } from '@aws-amplify/auth';
import { accountService, TokensHolder } from '../services';

export const getEncryptedTokens = async (user?: CognitoUser) => {
	if (!user) {
		throw new Error('user is undefined.');
	}

	const session = user.getSignInUserSession();

	if (!session) {
		throw new Error('user session is undefined.');
	}

	const jwtToken = session.getIdToken().getJwtToken();
	const refreshToken = session.getRefreshToken().getToken();

	try {
		return accountService.verifySignIn(jwtToken, refreshToken);
	} catch (error) {
		throw error;
	}
};

interface SetHackettAccessTokenHeadersArgs {
	defaultUrl?: string;
	token?: TokensHolder;
	deviceKey?: string;
}

export const setHackettAccessTokenHeaders = ({ defaultUrl, token, deviceKey }: SetHackettAccessTokenHeadersArgs) => {
	const searchParams = new URLSearchParams(defaultUrl);

	if (token?.accessToken) {
		searchParams.set('X-Hackett-Access-Token', token.accessToken);
	}
	if (token?.refreshToken) {
		searchParams.set('X-Hackett-Refresh-Token', token.refreshToken);
	}
	if (deviceKey) {
		searchParams.set('X-Hackett-Device-Key', deviceKey);
	}

	return searchParams;
};
